import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/buttons.css';
import './styles/controls.css';
import './styles/page-mobile.css';
import "react-datepicker/dist/react-datepicker.css";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from "./app/store";
import { logout } from "./features/auth/authSlice";

// If any API call gets 401 (invalid access token) => logout + redirect to login
window.addEventListener("auth:unauthorized", () => {
  store.dispatch(logout());
  const base = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");
  window.location.assign(`${base}/auth/login`);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={process.env.PUBLIC_URL || "/"}>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
